<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <UnmatchedProjects/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import UnmatchedProjects from "@/view/pages/realstate/merging/inc/UnmatchedProjects.vue";

export default {
  name: 'unmatched-data',
  components: {
    UnmatchedProjects,
  },
  data() {
    return {}
  },
  watch: {},
  mounted() {

  },
  methods: {},
  computed: {
    ...mapState({
      errors: state => state.merge.errors
    }),
  }
};
</script>